var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveBurger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_81_2407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 3.68629 4.68629 1 8 1H36C39.3137 1 42 3.68629 42 7V35C42 38.3137 39.3137 41 36 41H8C4.68629 41 2 38.3137 2 35V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5H36C39.0376 1.5 41.5 3.96243 41.5 7V35C41.5 38.0376 39.0376 40.5 36 40.5H8C4.96243 40.5 2.5 38.0376 2.5 35V7C2.5 3.96243 4.96243 1.5 8 1.5Z",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_2407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7527 14.1934C19.0621 14.4716 19.0871 14.9434 18.809 15.2528L16.559 17.7528C16.4215 17.9059 16.2277 17.9966 16.0215 17.9997C15.8152 18.0028 15.6184 17.9247 15.4715 17.7809L14.2184 16.5309C13.9277 16.2372 13.9277 15.7622 14.2184 15.4684C14.509 15.1747 14.9871 15.1747 15.2777 15.4684L15.9684 16.1591L17.6902 14.2466C17.9684 13.9372 18.4402 13.9122 18.7496 14.1903L18.7527 14.1934ZM18.7527 19.1934C19.0621 19.4716 19.0871 19.9434 18.809 20.2528L16.559 22.7528C16.4215 22.9059 16.2277 22.9966 16.0215 22.9997C15.8152 23.0028 15.6184 22.9247 15.4715 22.7809L14.2184 21.5309C13.9246 21.2372 13.9246 20.7622 14.2184 20.4716C14.5121 20.1809 14.9871 20.1778 15.2777 20.4716L15.9684 21.1622L17.6902 19.2497C17.9684 18.9403 18.4402 18.9153 18.7496 19.1934H18.7527ZM20.9996 15.9997C20.9996 15.4466 21.4465 14.9997 21.9996 14.9997H28.9996C29.5527 14.9997 29.9996 15.4466 29.9996 15.9997C29.9996 16.5528 29.5527 16.9997 28.9996 16.9997H21.9996C21.4465 16.9997 20.9996 16.5528 20.9996 15.9997ZM20.9996 20.9997C20.9996 20.4466 21.4465 19.9997 21.9996 19.9997H28.9996C29.5527 19.9997 29.9996 20.4466 29.9996 20.9997C29.9996 21.5528 29.5527 21.9997 28.9996 21.9997H21.9996C21.4465 21.9997 20.9996 21.5528 20.9996 20.9997ZM18.9996 25.9997C18.9996 25.4466 19.4465 24.9997 19.9996 24.9997H28.9996C29.5527 24.9997 29.9996 25.4466 29.9996 25.9997C29.9996 26.5528 29.5527 26.9997 28.9996 26.9997H19.9996C19.4465 26.9997 18.9996 26.5528 18.9996 25.9997ZM15.4996 24.4997C15.8974 24.4997 16.279 24.6577 16.5603 24.939C16.8416 25.2203 16.9996 25.6019 16.9996 25.9997C16.9996 26.3975 16.8416 26.779 16.5603 27.0603C16.279 27.3417 15.8974 27.4997 15.4996 27.4997C15.1018 27.4997 14.7203 27.3417 14.4389 27.0603C14.1576 26.779 13.9996 26.3975 13.9996 25.9997C13.9996 25.6019 14.1576 25.2203 14.4389 24.939C14.7203 24.6577 15.1018 24.4997 15.4996 24.4997Z",
    fill: "#092E5E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_81_2407",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81_2407"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81_2407",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_2407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(14 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveBurger);
export default __webpack_public_path__ + "static/media/ic_active_burger.1208d494b8bf18e6d92597eed6c3c9e7.svg";
export { ForwardRef as ReactComponent };